import React from "react";
import { FormattedMessage } from "react-intl";
import tripStatus from "../constants/tripStates";

const BADGES = {
    default: {
        title: "",
        color: "default",
    },
    [tripStatus.PENDING]: {
        title: <FormattedMessage id="trip.status-pending" />,
        color: "danger",
    },
    [tripStatus.MOVING]: {
        title: <FormattedMessage id="trip.status-in-progress" />,
        color: "warning",
    },
    [tripStatus.COMPLETED]: {
        title: <FormattedMessage id="trip.status-completed" />,
        color: "secondary",
    },
    [tripStatus.ARRIVED]: {
        title: <FormattedMessage id="trip.status-arrived" />,
        color: "primary",
    },
    [tripStatus.CANCELLED]: {
        title: <FormattedMessage id="trip.status-canceled" />,
        color: "#920000",
    },
    [tripStatus.UNFULFILLED]: {
        title: <FormattedMessage id="trip.status-unfulfilled" />,
        color: "#F98510",
    },
    [tripStatus.NOT_REQUESTED]: {
        title: <FormattedMessage id="trip.status-not-requested" />,
        color: "#D3DAE6",
    },
    [tripStatus.NOT_LOADED]: {
        title: <FormattedMessage id="trip.status-not-loaded" />,
        color: "#9D4EDD",
    },
    [tripStatus.ABSENT]: {
        title: <FormattedMessage id="trip.status-absent" />,
        color: "#EF233C",
    },
};

export default BADGES;
